import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'scientificNotation'
})
export class ScientificNotationPipe implements PipeTransform {
  transform(value: number): string {
    return value.toExponential(3).replace('e', 'E');
  }

  //new change for pagonation error by roshani
  // transform(value: any): string {

  //   if (value === null || value === undefined || value === '') {
  //     return '-';
  //   }

  //   const numberValue = Number(value);

  //   if (isNaN(numberValue)) {
  //     return '-';
  //   }

  //   return numberValue.toExponential(3).replace('e', 'E');
  // }
}
